import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { GroupAdminService } from 'src/app/services/GroupAdmin/group-admin.service';

@Component({
  selector: 'app-group-profile',
  templateUrl: './group-profile.component.html',
  styleUrls: ['./group-profile.component.css']
})
export class GroupProfileComponent implements OnInit {
  Submitted: boolean = false;
  SchoolList: any;
  Country: any;
  State: any;
  PartnerType: any;
  SelectedFileForUpload: any;
  PartnerList: any;
  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
  constructor(private ng2ImgMax: Ng2ImgMaxService,private superadminservice: GroupAdminService, private lookupservice: LookupService, 
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

   
  GetSchoolDetails() {
    this.spinnerService.show();   
    this.superadminservice.GetSchoolDetails().subscribe((data: any) => {
      this.SchoolModel = data.OrganizationDetails;
      this.GetState();
      this.SchoolModel.StateID = this.SchoolModel.StateID;
      this.spinnerService.hide();

    });
  };
  SchoolModel = {
    Address: '',
    DirectorName: '',
    GroupName: '',
    POBox: '',
    Email: '',
    ZipCode: '',
    MobileNo: '',
    Phone: '',
    IsActive: true,
    CountryID: 0,
    CityID: 0,
    StateID: 0,
    SchoolID: 0,
    LogoPath: '',
    UserID: '',
    CurrencyCode:'',
    CityName:'',
  };

    
  validationDropDown() {
    return this.SchoolModel.CountryID == 0 || this.SchoolModel.StateID == 0|| this.SchoolModel.CityName=='';
  }

  uploadedImage:Blob;
  onImageChange(event) {
    this.spinnerService.show();
    let image = event.target.files[0];     
    this.ng2ImgMax.compressImage(image,2).subscribe(
      result => {
       this.SelectedFileForUpload=result;
      
       this.spinnerService.hide();
      },
      error => {
        this.SelectedFileForUpload=image;
        
        this.spinnerService.hide();
        
      }
    );
  }

  SaveSchoolDetails(valid) {
    this.Submitted = true;
    if (valid && !this.validationDropDown()) {
      this.spinnerService.show();
      this.superadminservice.SaveSchoolDetails(JSON.stringify(this.SchoolModel), (this.SelectedFileForUpload)).subscribe((response: any) => {
        this.GetSchoolDetails();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response)
      });
    }
  };

  ngOnInit() {
    this.GetBindCountry();
    this.GetPartner();
    this.BindCity();
    this.GetSchoolDetails();


  }
  CityList=[];
   BindCity(){
     this.SchoolModel.CityID=0;
    var ItemBO = {
      'ItemId': this.SchoolModel.StateID,
      'ItemName': this.SchoolModel.CityName,
    }
    this.spinnerService.show();
    this.lookupservice.GetLookupsList('AllCity', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.CityList = data.LookupItems;
      this.CityList.splice(0,1);
      this.spinnerService.hide();
    });
   }

   SelectedCity(item){
     this.SchoolModel.CityID=item.CityID;
   }
  GetBindCountry() {
    this.lookupservice.GetLookupsList('Country', '').subscribe((data: any) => {
      this.Country = data.LookupItems;
    });
  };


  GetPartner() {
    this.lookupservice.GetLookupsList('Partner', '').subscribe((data: any) => {
      this.PartnerList = data.LookupItems;
    });
  };

  GetState() {
    var Itembo = {
      'ItemId': this.SchoolModel.CountryID
    }
    this.lookupservice.GetLookupsList('State', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.State = data.LookupItems;
    });
  };

  GetPartnerType() {

    this.lookupservice.GetLookupsList('Partner', '').subscribe((data: any) => {
      this.PartnerType = data.LookupItems;
    });
  };

  GetCity() {
    this.SchoolModel.CityID=0;
    this.SchoolModel.CityName='';
    var Itembo = {
      'ItemId': this.SchoolModel.StateID
    }
    this.lookupservice.GetLookupsList('City', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.CityList = data.LookupItems;
      this.CityList.splice(0,1);
    });
  };

}


